import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "number",
  "customer",
  "asset",
  "serial",
  "description",
  "tasks",
  "department",
  "start",
  "due",
  "updated",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const DEFAULT_COLUMNS: Column[] = [...COLUMNS]

export const COLUMN_LABELS: Record<Column, string> = {
  number: "WO no.",
  customer: "Customer",
  asset: "Asset",
  serial: "Serial no.",
  description: "Description",
  tasks: "Tasks",
  department: "Department",
  start: "Start",
  due: "Due",
  updated: "Updated",
}

export type Slot = Column | "status" | "actions"

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "work-orders",
  widths: {
    number: 7.5,
    status: 2,
    customer: 11,
    asset: 8,
    serial: 7,
    description: 14,
    tasks: 5,
    department: 8,
    start: 6,
    due: 6,
    updated: 8.5,
    actions: 3.25,
  },
  fill: "description",
  pinned: ["status", "actions"],
  extras: ["status", "actions"],
  dropOrder: [
    "serial",
    "start",
    "department",
    "updated",
    "asset",
    "due",
    "customer",
    "tasks",
  ],
}

export function withNumber(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => column === "number" || columns.includes(column),
  )
}

export function slotsOf(columns: Column[]): Slot[] {
  const rest = COLUMNS.filter(
    (column) => column !== "number" && columns.includes(column),
  )
  return ["number", "status", ...rest, "actions"]
}
